<template>
  <section class="mt-3 mb-3">
    <jet-button 
      icon="fas fa-exclamation"
      btnStyle="danger"
      class="py-2 px-4 mb-2"
      @click="expanded = !expanded"
    >
      Report Issue With Shipment
    </jet-button>

    <div v-if="expanded" class="mt-3 col-12 col-lg-4 px-0">
      <textarea class="form-control" v-model="formNote.content"></textarea>

      <div class="d-flex mt-2">
        <jet-button class="mr-2 btn-sm" @click="submitNote">Submit Issue</jet-button>
        <jet-button class="btn-sm" btnStyle="danger" @click="expanded = false">Cancel</jet-button>
      </div>
    </div>

    <div v-if="notes && notes.length" class="mt-3">
      <h4 class="text-dark font-weight-bold">Your Requests</h4>

      <ul class="list-group">
        <li v-for="note in notes" :key="note.id" class="list-group-item">
          <p class="text-dark text-size-small mb-0">By: {{ note.user }} on {{ moment(note.date).format('M/D/YY h:mm A') }}</p>
          <p class="mb-0">{{note.content}}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        expanded: false,
        formNote: this.$inertia.form({
          _method: 'put',
          content: null,
        }),
      }
    },
    props: {
      notes: Array,
    },
    created() {
      this.moment = moment
    },
    methods: {
      submitNote() {
        this.expanded = false
        this.formNote.post(this.route('mtd.user.addnote'), {
          preserveScroll: true
        })
      }
    }
  }
</script>
